/**
 * Meal Mems Cart Display
 *
 * Hides Size and Orientation options in cart display for Digital Downloads.
 * Digital downloads don't have size/orientation - they're just a high-res file.
 */

(function() {
  'use strict';

  function hideDigitalSizeOrientation() {
    // Find all product-option divs inside elements that contain "Digital Download"
    var productOptions = document.querySelectorAll('.product-option');

    productOptions.forEach(function(optionDiv) {
      // Check if this option's parent/ancestor contains "Digital Download"
      var parent = optionDiv.closest('dl, .cart-notification-product, .cart-item, [class*="cart"]');
      if (!parent) return;

      var parentText = parent.textContent || '';
      if (parentText.indexOf('Digital Download') === -1) return;

      // Check if this option is Size or Orientation
      var dt = optionDiv.querySelector('dt');
      if (dt) {
        var label = dt.textContent.trim();
        if (label === 'Size:' || label === 'Orientation:') {
          optionDiv.style.display = 'none';
        }
      }
    });

    // Also handle dt/dd pairs not wrapped in .product-option (cart page might be different)
    var definitionLists = document.querySelectorAll('dl');
    definitionLists.forEach(function(dl) {
      var dlText = dl.textContent || '';
      if (dlText.indexOf('Digital Download') === -1) return;

      // Find dt elements directly in this dl (not in .product-option wrappers)
      var dts = dl.querySelectorAll('dt');
      dts.forEach(function(dt) {
        var label = dt.textContent.trim();
        if (label === 'Size:' || label === 'Orientation:') {
          // Check if it's in a .product-option wrapper
          var wrapper = dt.closest('.product-option');
          if (wrapper) {
            wrapper.style.display = 'none';
          } else {
            // Hide dt and its following dd sibling
            dt.style.display = 'none';
            var next = dt.nextElementSibling;
            if (next && next.tagName === 'DD') {
              next.style.display = 'none';
            }
          }
        }
      });
    });
  }

  // Run immediately
  hideDigitalSizeOrientation();

  // Run on DOMContentLoaded
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', hideDigitalSizeOrientation);
  }

  // Use MutationObserver on body to catch dynamic content (like the cart notification popup)
  var observer = new MutationObserver(function() {
    hideDigitalSizeOrientation();
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true
  });

  console.log('[MealMems] Cart display script loaded');
})();
